"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _auth = require("@/utils/auth");
var _TimeLine = _interopRequireDefault(require("../../../components/TimeLine.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default2 = exports.default = {
  name: 'CardLivenessHistory',
  components: {
    Card: _components.Card,
    TimeLine: _TimeLine.default
  },
  props: {
    history: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    isAdmin: function isAdmin() {
      var _getUser, _getUser$user;
      return Boolean((_getUser = (0, _auth.getUser)()) === null || _getUser === void 0 ? void 0 : (_getUser$user = _getUser.user) === null || _getUser$user === void 0 ? void 0 : _getUser$user.roleAdmin);
    },
    historyList: function historyList() {
      var _this = this;
      return this.history.map(function (item, index) {
        return _objectSpread(_objectSpread({}, item), {}, {
          eventDate: (item === null || item === void 0 ? void 0 : item.createdAt) || (item === null || item === void 0 ? void 0 : item.updatedAt) || null,
          deviceEntries: _this.normalizeDeviceEntries(item === null || item === void 0 ? void 0 : item.logDevice),
          headerEntries: _this.isAdmin ? _this.normalizeHeaderEntries(item === null || item === void 0 ? void 0 : item.headersLog) : [],
          position: index % 2 === 0 ? 'left' : 'right'
        });
      });
    },
    latestHistoryDate: function latestHistoryDate() {
      return this.historyList.reduce(function (latest, item) {
        if (!(item !== null && item !== void 0 && item.eventDate)) {
          return latest;
        }
        if (!latest) {
          return item.eventDate;
        }
        return new Date(item.eventDate) > new Date(latest) ? item.eventDate : latest;
      }, null);
    },
    historySummary: function historySummary() {
      return {
        title: this.historyList.length > 1 ? 'Histórico consolidado da jornada' : 'Evento registrado na jornada',
        description: 'A visualização abaixo organiza os marcos do processo em uma linha do tempo mais clara e consistente com a experiência da aba facial.',
        tagLabel: this.historyList.length > 1 ? 'Completo' : 'Registro',
        tagClass: 'is-info',
        icon: 'history'
      };
    }
  },
  methods: {
    normalizeDeviceEntries: function normalizeDeviceEntries(logDevice) {
      var _this2 = this;
      if (!logDevice || _typeof(logDevice) !== 'object' || Array.isArray(logDevice)) {
        return [];
      }
      var labels = {
        browser: 'Navegador',
        browserVersion: 'Versão do navegador',
        operatingSystem: 'Sistema operacional',
        operatingSystemVersion: 'Versão do sistema',
        deviceType: 'Tipo de dispositivo'
      };
      return Object.entries(logDevice).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          value = _ref2[1];
        return value !== null && value !== undefined && value !== '';
      }).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        return {
          key: key,
          label: labels[key] || key,
          value: _this2.formatDetailValue(value)
        };
      });
    },
    normalizeHeaderEntries: function normalizeHeaderEntries(headersLog) {
      var _this3 = this;
      var headers = headersLog;
      if (typeof headersLog === 'string') {
        try {
          headers = JSON.parse(headersLog);
        } catch (error) {
          return [];
        }
      }
      if (!headers || _typeof(headers) !== 'object' || Array.isArray(headers)) {
        return [];
      }
      return Object.entries(headers).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];
        return {
          key: key,
          value: _this3.isSensitiveHeader(key) ? '••••••••' : _this3.formatDetailValue(value)
        };
      });
    },
    isSensitiveHeader: function isSensitiveHeader(key) {
      return /(authorization|cookie|token|secret|api[-_]?key)/i.test(String(key));
    },
    formatDetailValue: function formatDetailValue(value) {
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      if (_typeof(value) === 'object') {
        try {
          return JSON.stringify(value);
        } catch (error) {
          return String(value);
        }
      }
      return String(value);
    }
  }
};